import React from 'react';
import useSWR from 'swr'
import classNames from "classnames";
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { getBBHostApiProduct } from "constants.js";

import { NextSeo, ProductJsonLd } from 'next-seo';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Business, Security, Cloud, Public, ContactSupport, CheckCircle, BlurCircular, BlurOn } from '@material-ui/icons';

import Loading from 'components/Functions/Loading';
import { Paper } from '@material-ui/core';

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { loading: () => <Loading /> });
const Badge = dynamic(() => import('/components/Badge/Badge.js'));

const Accordions = dynamic(() => import('/components/Accordion/Accordions.js'));
const InfoArea = dynamic(() => import('/components/InfoArea/InfoArea.js'));
const InfoAreaLink = dynamic(() => import('/components/InfoArea/InfoAreaLink.js'));
const NavPills = dynamic(() => import('/components/NavPills/NavPills.js'));
const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { ssr: true });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'));
const ProductTabs = dynamic(() => import('/components/CustomTabs/ProductTabs.js'), { ssr: true });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
const styles = {
  ...landingPage,
  main: {
    background: "#f1f5f8",
    position: "relative",
    zIndex: "3",
    paddingTop: "30px",
  },
  section: {
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center",
  },
  title: {
    color: "#3C4858",
    margin: "1.75rem 0 0.875rem",
    textDecoration: "none",
    fontWeight: "700",
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
  }
};

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";

const ProductSection = dynamic(() => import('pages-sections/ProductSection.js'), { ssr: true, loading: () => <Loading /> });

const SEO = {
  title: "BB Host - Bare Metal",
  description: "Tenha seu próprio dedicado utilizando todos os recursos, sem compartilhamento!",
  url: "https://www.bbhost.com.br/baremetal",
  type: "website",
  languageAlternates: [
    {
      hrefLang: 'en',
      href: "https://www.bbhost.com.br/en/baremetal",
    },
    {
      hrefLang: 'es',
      href: "https://www.bbhost.com.br/es/baremetal",
    }
  ],
};

const useStyles = makeStyles(styles);

import { trans, getLangFromObj } from "lang/lang.js";

import { BAREMETAL_FAQS } from "configs/index";

const fetcher = (url) => fetch(url).then((res) => res.json());

export default function BareMetal(props) {
  const classes = useStyles();
  const { locale, defaultLocale } = useRouter();
  const { aggregateOffer } = props;
  let products_tab = <></>;
  let products_spot_tab = <></>;

  let productsTab = <Loading />;

  const faqsTabs = [
    {
      tabButton: trans('products::faqs.tabs.traffic'),
      tabIcon: Public,
      tabContent: (
        <div className={classes.section} style={{background: 'none'}}>
          <h2 className={classes.title}>{trans('products::faqs.tabs.traffic')}</h2>
          <GridContainer justifyContent="center" alignItems="center">
          <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Trafégo de download (entrada) gratuito."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="30TB de trafégo de upload (saída) inclusos em todos os serviços baremetal Brasil."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Pacotes de tráfego vendidos em incrementos de 10TB. O custo por TB de tráfego é de R$18,00 por mês."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info"
                icon={CheckCircle} 
                title="" 
                description="Trafégo calculado com base no uso dos últimos 30 dias."
              />
            </GridItem>
          </GridContainer>
        </div>
      )
    },
    {
      tabButton: trans('products::faqs.tabs.ips'),
      tabIcon: Cloud,
      tabContent: (
        <div className={classes.section} style={{background: 'none'}}>
          <h2 className={classes.title}>{trans('products::faqs.tabs.ips')}</h2>
          <GridContainer justifyContent="center" alignItems="center">
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="IPs adicionais tem custo de R$20,00 mensais por IP, limitados a 4 IPs adicionais por serviço."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Tenha seu próprio bloco sendo o mínimo /29 (5 ips), custando R$16,00 por ip mensal."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Utilize seu próprio bloco de IP (/24 ou maior), na modalidade BYO-IP por R$1.000,00 mensais (por /24)."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="IPv6 gratuito. 1 IPv6 (/128) para cada IP adicional ou 1 bloco IPv6 /48 no caso da contratação de blocos IPv4."
              />
            </GridItem>
          </GridContainer>   
        </div>
      )
    },
    {
      tabButton: trans('products::faqs.tabs.mitigation'),
      tabIcon: Security,
      tabContent: (
        <div className={classes.section} style={{background: 'none'}}>
          <h2 className={classes.title}>{trans('products::faqs.tabs.mitigation')}</h2>              
          <h4 className={classes.title}>Global Mitigation AlwaysOn</h4>
          <GridContainer justifyContent="center" alignItems="center">
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Mitigação de 248 Tbps inclusa sem custos adicionais, sendo a mesma sempre ativa."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Notificação por e-mail de ataques recebidos."
              />
            </GridItem>
          </GridContainer>
          <h4 className={classes.title}>DDoS Pro</h4>
          <GridContainer justifyContent="center" alignItems="center">
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="DDoS Pro para aplicações específicas com perfil de vários jogos e aplicações já existentes, caso não exista podemos criar um perfil para sua aplicação."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Custo de R$300,00 por ip no DDoS Pro, podendo utilizar portas ilimitadas."
              />
            </GridItem>
          </GridContainer>
        </div>   
      )
    },
    {
      tabButton: trans('products::faqs.tabs.support'),
      tabIcon: ContactSupport,
      tabContent: (
        <div className={classes.section} style={{background: 'none'}}>
          <h2 className={classes.title}>{trans('products::faqs.tabs.support')}</h2>
          <GridContainer justifyContent="center" alignItems="center">
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Suporte 24/7 via ticket, tenha atendimento personalizado conforme sua necessidade."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea 
                iconColor="info" 
                icon={CheckCircle} 
                title="" 
                description="Suporte Premium com SLA reduzido, tenha um canal de comunicação diretamente com o suporte nível 2 e engenharia de redes."
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <InfoArea
                iconColor="info"
                icon={CheckCircle}
                style={{maxWidth: "90%"}}
                title=""
                description="Suporte discord e WhatsApp para maior proximidade com o atendente. Caso queira marcar uma reunião em nosso discord, entre em contato para agendar."
              />
            </GridItem>
          </GridContainer>
        </div>         
      )
    }
  ];

  const highlights = BAREMETAL_FAQS.highlights.map((highlight, key) => {
    let highlight_icon = Business;
    
    if(highlight.icon == "Business")
    {
      highlight_icon = Business;
    }
    if(highlight.icon == "Security")
    {
      highlight_icon = Security;
    }
    if(highlight.icon == "Public")
    {
      highlight_icon = Public;
    }

    if(typeof highlight.text === "object")
    {
      highlight.text = getLangFromObj(highlight.text);
    }
    if(typeof highlight.subText === "object")
    {
      highlight.subText = getLangFromObj(highlight.subText);
    }

    if(highlight.more_link !== undefined)
    {
      if(typeof highlight.more_link.text === "object")
      {
        highlight.more_link.text = getLangFromObj(highlight.more_link.text);
      }

      return (
        <GridItem key={key} xs={12} sm={12} md={4}>
          <InfoAreaLink 
            iconColor={highlight.icon_color}
            icon={highlight_icon} 
            title={highlight.text} 
            description={highlight.subText}
            link={highlight.more_link}
          />
        </GridItem>
      );
    }

    return (
      <GridItem key={key} xs={12} sm={12} md={4}>
        <InfoArea 
          iconColor={highlight.icon_color}
          icon={highlight_icon} 
          title={highlight.text} 
          description={highlight.subText}
        />
      </GridItem>
    );
  });

  const { data: dataBaremetal } = useSWR('https://api-frontend-site.bbhost.com.br/products-baremetal', fetcher)
  const { data: dataBaremetalSpot } = useSWR('https://api-frontend-site.bbhost.com.br/products-baremetal-spot', fetcher)

  if(dataBaremetal) {
    products_tab = (<ProductSection name="baremetal" products={dataBaremetal.products} out_of_stock={dataBaremetal.outStockAll} locale={{ locale, defaultLocale }} update />);
  }

  if(dataBaremetalSpot) {
    products_spot_tab = (<ProductSection name="baremetal" products={dataBaremetalSpot.products} out_of_stock={dataBaremetalSpot.outStockAll} locale={{ locale, defaultLocale }} spots={true} update />);
  }

  if(dataBaremetal && dataBaremetalSpot)
  {
    productsTab = (<ProductTabs
      headerColor="success"
      tabs={[
        {
          tabName: "Principal",
          tabIcon: BlurCircular,
          tabContent: products_tab
        },
        {
          tabName: "Spot",
          tabIcon: BlurOn,
          tabContent: products_spot_tab
        }
      ]}
      defaultValue={0}
      tabSyle={{
        variant: "scrollable",
        scrollButtons: "auto",
        "aria-label": "scrollable auto tabs example"
      }}
    />);
  }

  return (
    <>
    <NextSeo
        openGraph={{
            type: SEO.type,
            url: SEO.url,
            title: SEO.title,
            description: SEO.description,
            images: [
                {
                    url: "https://cdn.bbhost.com.br/images/bg/capa_fundo_dedicado.png",
                    width: 800,
                    height: 600,
                    alt: SEO.description,
                },
            ],
        }}
    />
    <ProductJsonLd
      productName="Baremetal"
      images={[]}
      description={SEO.description}
      aggregateRating={{
        ratingValue: '5.0',
        reviewCount: '200',
      }}
      aggregateOffer={aggregateOffer}
    />
    <div>
      <HeaderSection name="baremetal" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            {productsTab}
          </div>
          
          <GridContainer justifyContent="center" alignItems="center">
            <GridItem xs={12} sm={12} md={12}>
              <Paper elevation={10} style={{marginBottom: "15px", padding: "10px"}}>
                <NavPills
                  color="info"
                  tabs={faqsTabs}
                  alignCenter
                  horizontal={{
                    tabsGrid: { xs: 12, sm: 2, md: 2 },
                    contentGrid: { xs: 12, sm: 10, md: 10 }
                  }}
                />
              </Paper>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer justifyContent="center" alignItems="center">
                {highlights}
              </GridContainer>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <h5 className={classes.textCenter}><Badge color="info">{trans('products::faqs.title')}</Badge></h5>
              <GridContainer justifyContent="center" alignItems="center">                            
                <GridItem xs={12} sm={12} md={12}>
                  <Accordions itens={BAREMETAL_FAQS.list} />
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
}

export async function getStaticProps({ req, res }) {
  let aggregateOffer = {
    lowPrice: 0,
    highPrice: 0,
    priceCurrency: 'BRL',
    offers: []
  };

  try
  {
    let products_data_api = await getBBHostApiProduct("baremetal?aggregateOffer=1");
    products_data_api = products_data_api.data;
    if(products_data_api.aggregateOffer !== undefined)
    {
      aggregateOffer = products_data_api.aggregateOffer;
    }
    
    return {
      props: {
        aggregateOffer
      },
    }
  }
  catch (error) 
  {
    console.error(error);
    return {
      props: {
        aggregateOffer
      },
    }
  }
}